export const ProviderTypesEnum = {
    FACILITY : "F",
    PROFESSIONAL : "P"
}

export const ProviderTypes = [
    { value: ProviderTypesEnum.PROFESSIONAL, label: 'PROFESSIONAL (GROUP OR INDIVIDUAL)' }
];